module.exports = __webpack_public_path__ + "img/mockup-assistente.63ee6a7e.jpeg";